import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArSiteSetupFormLockAccessAddedApprovalNotifyAuthorProps extends BaseTemplateProps {
  request: {
    name: string
  }
}

export const ArSiteSetupFormLockAccessAddedApprovalNotifyAuthor: TemplateDefinition<ArSiteSetupFormLockAccessAddedApprovalNotifyAuthorProps> =
  {
    renderParams: (props: ArSiteSetupFormLockAccessAddedApprovalNotifyAuthorProps) => ({
      messageKey:
        'notificationsDomain.templates.arSiteSetupFormLockAccessAddedApprovalNotifyAuthor',
      values: {
        siteName: props?.request?.name,
      },
    }),
    getLink: (props: ArSiteSetupFormLockAccessAddedApprovalNotifyAuthorProps): string => {
      if (!props) return ''
      return '/app/admin/approvals-management/approval-requests-search?tool=site_setup_form_lock_access'
    },
  }
